'use client';

import { Stack, Typography } from '@mui/material';
import Image from 'next/image';

import { backgrounds } from '@/assets/materials';
import { BUILD_WITH_US_URL } from '@/global/configs/common';
import { useGA } from '@/hooks/useGA';

import HexagonalButton from './bases/HexagonalButton';

export const FAQsSection = () => {
  const { trackButtonClickEvent } = useGA();

  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      alignItems={'center'}
      component={'section'}
      position={'relative'}>
      <Stack
        width={'100%'}
        padding={{ xs: '40px 24px', sm: '80px' }}
        alignItems={'center'}
        height={{ xs: '460px', sm: '920px' }}
        position={'relative'}>
        <Stack gap={{ xs: 3, sm: 7 }} width={'min(1280px, 100%)'} zIndex={2} alignItems={'center'}>
          <Typography
            component={'h2'}
            variant={'displayMedium'}
            className={'clip-text'}
            textAlign={'center'}
            whiteSpace={'pre-line'}
            fontSize={{ xs: '24px', sm: '48px' }}
            lineHeight={{ xs: '32px', sm: '68px' }}
            sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
            {`FUND, ACCELERATE, AND SCALE\nYOUR PROJECT WITH OUR CORE SALE\nPROGRAM.`}
          </Typography>
          <Stack width={'219px'}>
            <HexagonalButton
              variant={'secondary'}
              label={'BUILD WITH US'}
              onClick={() => {
                trackButtonClickEvent({ name: 'build_with_us' });
                window.open(BUILD_WITH_US_URL, '_blank');
              }}
            />
          </Stack>
        </Stack>
        <Stack zIndex={1} position={'absolute'} top={0} left={0} right={0} bottom={0}>
          <Image src={backgrounds.why_lfg_bg} alt={''} layout={'fill'} objectFit={'cover'} />
        </Stack>
      </Stack>
    </Stack>
  );
};
